module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-list', {
    attrs: {
      "id": "hcp-recent-questions"
    }
  }, [_vm._l((_vm.amount), function(item, index) {
    return (_vm.isLoading) ? _c('mu-list-item', {
      key: 'dummy-loader-' + index,
      staticClass: "noCursor",
      attrs: {
        "title": item.display_name
      }
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "width": "50%",
        "height": "14px",
        "background": "rgb(214, 214, 214)",
        "margin-bottom": "8px"
      },
      style: ({
        width: _vm.getRandomArbitrary(40, 50)
      }),
      attrs: {
        "slot": "describe",
        "color": "#d9d9d9"
      },
      slot: "describe"
    }), _vm._v(" "), _vm._o(_c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": item.image,
        "color": "white",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }), 0, 'dummy-loader-' + index), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "height": "12px",
        "width": "15%",
        "background": "#f1f1f1"
      },
      attrs: {
        "color": "#d9d9d9"
      }
    })], 1)], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.questions), function(q, index) {
    return _c('div', {
      key: ("question-" + index),
      staticClass: "item-wrap"
    }, [(!_vm.isLoading) ? _c('mu-list-item', {
      attrs: {
        "titleClass": "blueTitle",
        "title": q.question,
        "describeText": ("by " + (q.display_name ? q.display_name : q.firstname + ' ' + q.surname) + ", " + (_vm.date(q.timestamp))),
        "disableRipple": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goToQuestionThread(q.question_id)
        }
      }
    }, [(!q.profile_large) ? _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "color": "#0179d5",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }, [_vm._v("\n        " + _vm._s(_vm.upperTwoInitials(q.display_name ? q.display_name : q.firstname + ' ' + q.surname)) + "\n      ")]) : _vm._e(), _vm._v(" "), (q.profile_large) ? _vm._o(_c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": q.profile_large,
        "color": "white",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }), 1, ("question-" + index)) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "q-stats",
      attrs: {
        "slot": "right"
      },
      slot: "right"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(((q.likes) + " likes"))
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(((q.replies) + " replies"))
      }
    })])], 1) : _vm._e(), _vm._v(" "), (index + 1 !== _vm.questions.length) ? _c('mu-divider', {
      attrs: {
        "inset": true
      }
    }) : _vm._e()], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10347eda","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HCP/LatestQuestions.vue
// module id = 3602
// module chunks = 1